<template>
  <div>
    <my-asidebar v-bind:active-tab="'sail'"> </my-asidebar>

    <section class="dashboard-area">
      <top-bar></top-bar>
      <div class="dashboard-content-wrap">
        <div class="dashboard-bread dashboard--bread dashboard-bread-2">
          <div class="container-fluid">
            <div class="row align-items-center">
              <div class="col-lg-6">
                <div class="breadcrumb-content">
                  <div class="section-heading">
                    <h2 class="sec__title font-size-30 text-white">Sefer</h2>
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="breadcrumb-list text-right">
                  <ul class="list-items">
                    <li><a :href="basePath" class="text-white">Anasayfa</a></li>
                    <li>Sefer</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="dashboard-main-content">
          <div class="container-fluid">
            <div class="row">
              <div class="col-lg-12">
                <div class="form-box" v-if="sailList !== null">
                  <div class="d-flex align-items-center justify-content-end mr-4">
                    <sail-batch-update-modal :sail-list="sailList"/>
                    <a href="javascript:void(0)" :href="basePath+'/sails/new'" class="theme-btn theme-btn-small">
                      <i class="la la-plus mr-1"></i>
                      Sefer Yarat
                    </a>
                  </div>
                  <sail-list :sail-list="sailList"></sail-list>
                </div>
              </div>
            </div>
          </div>
          <div class="loader col-lg-12 mt-5" id="loader" v-if="sailList === null">
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
import TopBar from "../component/common/TopBar";
import MyAsidebar from "../component/common/MyAsidebar";
import SailList from "../component/sail/SailList";
import SailBatchUpdateModal from "../component/sail/SailBatchUpdateModal";


export default {
  name: "SailListPage",
  components: {SailList, MyAsidebar, TopBar,   SailBatchUpdateModal},
  data:function (){
    return {
      sailList: null
    };
  },
  computed:{
    basePath:{
      get(){
        return this.$store.getters.getBasePath
      }
    },
    panelRights: {
      get() {
        return this.$store.getters.getPanelRightsMap;
      }
    }
  },
  mounted() {
    if(!this.panelRights["PANEL_PAGE_SAIL_LIST"]) this.$router.push("/");
    this.$store.dispatch("loadSailsLite").then(response => {
      let sailList = response;

      if(sailList == null){
        return null;
      }

      sailList.sort((a, b) => {
        var dateA = new Date(a.sailDate);
        var dateB = new Date(b.sailDate);
        return dateA - dateB;
      });

      this.$store.dispatch("loadSeaTourList").then(response => {
        let seaTourMap = response.reduce(function (map, seaTour) {
          map[seaTour.id] = seaTour;
          return map;
        }, {});

        for (let i = 0; i < sailList.length; i++) {
          sailList[i].seaTour = seaTourMap[sailList[i].seaTourId];
        }

        this.sailList = sailList;
      })



      // return this.$store.getters.getSailList;
    });
    this.$store.dispatch("loadAgencyList");
  }
}
</script>

<style scoped>

.mt-5 {
  margin-top: 20% !important;
}

.loader {
  border: 16px solid #f3f3f3; /* Light grey */
  border-top: 16px solid #2877b5; /* Blue */
  border-radius: 50%;
  width: 120px;
  height: 120px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

</style>